// French translations for Twize Gateway UI

export const fr = {
  // Common
  common: {
    back: 'Retour',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    save: 'Enregistrer',
    close: 'Fermer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    ok: 'OK',
    yes: 'Oui',
    no: 'Non',
    actions: 'Actions',
    search: 'Rechercher',
    filter: 'Filtrer',
    noData: 'Aucune donnée trouvée',
    na: 'N/A',
  },

  // Navigation
  nav: {
    dashboard: 'Tableau de bord',
    systemUsers: 'Utilisateurs système',
    consumers: 'Consommateurs',
    debts: 'Dettes',
    logout: 'Déconnexion',
    twizeGateway: 'Twize Gateway',
  },

  // User Types
  userTypes: {
    twizeAdmin: 'Administrateur système',
    partnerManager: 'Gestionnaire de banque',
    partnerEmployee: 'Employé de banque',
    consumer: 'Consommateur',
    user: 'Utilisateur',
    systemAdmin: 'Administrateur système',
    bankManager: 'Gestionnaire de banque',
    bankEmployee: 'Employé de banque',
  },

  // Login Page
  login: {
    title: 'Twize Gateway',
    subtitle: 'Connectez-vous à votre compte',
    username: 'Nom d\'utilisateur',
    usernamePlaceholder: 'Entrez votre nom d\'utilisateur',
    password: 'Mot de passe',
    passwordPlaceholder: 'Entrez votre mot de passe',
    signIn: 'Se connecter',
    signingIn: 'Connexion en cours...',
  },

  // Dashboard
  dashboard: {
    title: 'Tableau de bord',
    welcome: 'Bienvenue dans le système de gestion Twize Gateway',
    systemUsers: {
      title: 'Utilisateurs système',
      description: 'Gérer les employés de banque',
      goTo: 'Aller aux utilisateurs système',
    },
    consumers: {
      title: 'Consommateurs',
      description: 'Voir et gérer les consommateurs',
      goTo: 'Aller aux consommateurs',
    },
    debts: {
      title: 'Dettes',
      description: 'Gérer les informations de dette et les paiements',
      goTo: 'Aller aux dettes',
    },
  },

  // System Users Page
  systemUsers: {
    title: 'Gestion des utilisateurs système',
    description: {
      admin: 'Créer et gérer tous les types d\'utilisateurs ',
      employee: 'Gérer les employés de banque ',
    },
    createUser: {
      title: 'Créer un nouvel utilisateur système',
      bank: 'Banque',
      bankRequired: 'Banque *',
      bankHint: 'Les utilisateurs système seront créés pour votre banque',
      userType: 'Type d\'utilisateur',
      userTypeRequired: 'Type d\'utilisateur *',
      username: 'Nom d\'utilisateur',
      usernameRequired: 'Nom d\'utilisateur *',
      usernamePlaceholder: 'Entrez le nom d\'utilisateur',
      password: 'Mot de passe',
      passwordRequired: 'Mot de passe *',
      passwordPlaceholder: 'Entrez le mot de passe (min 8 caractères)',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
      consumerNote: 'ℹ️ Les consommateurs n\'ont pas besoin de nom d\'utilisateur et de mot de passe. Ils seront identifiés par leur NNI.',
      create: 'Créer',
      creating: 'Création en cours...',
      cancel: 'Annuler',
    },
    table: {
      title: {
        admin: 'Tous les utilisateurs système',
        employee: 'Tous les employés de banque',
      },
      username: 'Nom d\'utilisateur',
      bank: 'Banque',
      userType: 'Type d\'utilisateur',
      actions: 'Actions',
      delete: 'Supprimer',
      deleting: 'Suppression...',
      loading: 'Chargement des utilisateurs...',
      empty: 'Aucun utilisateur système trouvé. Créez-en un ci-dessus !',
    },
    messages: {
      userCreated: '{{userType}} "{{userName}}" créé avec succès !',
      userDeleted: 'Utilisateur "{{userName}}" supprimé avec succès !',
      userIdNotFound: 'ID utilisateur introuvable. Veuillez vous déconnecter et vous reconnecter.',
      usernameRequired: 'Le nom d\'utilisateur est requis pour ce type d\'utilisateur.',
      passwordRequired: 'Le mot de passe est requis et doit contenir au moins 8 caractères.',
      createFailed: 'Échec de la création de l\'utilisateur système',
      deleteFailed: 'Échec de la suppression de l\'utilisateur',
      deleteConfirm: 'Supprimer l\'utilisateur',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer l\'utilisateur "{{userName}}" ?',
    },
  },

  // Consumers/Users Page
  consumers: {
    title: 'Gestion des consommateurs',
    createConsumer: 'Créer un consommateur',
    downloadTemplate: 'Télécharger le modèle d\'utilisateur',
    uploadUsers: 'Télécharger des utilisateurs',
    loading: 'Chargement des utilisateurs...',
    empty: 'Aucun utilisateur trouvé',
    table: {
      firstName: 'Prénom',
      lastName: 'Nom',
      nni: 'NNI',
      phoneNumber: 'Numéro de téléphone',
      bank: 'Banque',
      userType: 'Type d\'utilisateur',
      availableBalance: 'Solde disponible',
      actions: 'Actions',
    },
    viewDebts: 'Dettes',
    deleteConsumer: 'Supprimer',
    deletingConsumer: 'Suppression...',
    messages: {
      consumerCreated: 'Consommateur créé avec succès !',
      consumerDeleted: 'Consommateur supprimé avec succès.',
      deleteConsumerFailed: 'Échec de la suppression du consommateur.',
      deleteConsumerConfirm: 'Supprimer le consommateur {{phoneNumber}} ?',
      uploadSuccess: 'Utilisateurs téléchargés avec succès !',
      uploadFailed: 'Échec du téléchargement du fichier. Veuillez vérifier la connexion au backend.',
      downloadFailed: 'Échec du téléchargement du modèle',
      downloadFailedNoBank: 'Impossible de télécharger le modèle : Votre compte utilisateur n\'a pas de banque assignée. Veuillez contacter un administrateur ou vous connecter avec un compte spécifique à une banque.',
      downloadFailedGeneric: 'Échec du téléchargement du modèle. Veuillez vous assurer que vous êtes connecté avec un compte bancaire valide.',
    },
  },

  // Debts Page
  debts: {
    title: 'Gestion des dettes',
    downloadTemplate: 'Télécharger le modèle mensuel',
    uploadUpdate: 'Charger la mise à jour mensuelle',
    loading: 'Chargement des dettes...',
    empty: 'Aucune dette trouvée',
    table: {
      debtId: 'ID de la dette',
      userNni: 'NNI consommateur',
      totalDebt: 'Dette totale',
      totalPaid: 'Total payé',
      totalRemaining: 'Total restant',
      installments: 'Échéances',
      viewDetails: 'Voir les détails',
    },
    messages: {
      uploadSuccess: 'Mise à jour mensuelle téléchargée avec succès !',
      uploadFailed: 'Échec du téléchargement du fichier. Veuillez vérifier la connexion au backend.',
      downloadFailed: 'Échec du téléchargement du modèle. Veuillez vérifier la connexion au backend.',
    },
  },

  // Debt Details Modal
  debtDetails: {
    title: 'Dettes pour {{firstName}} {{lastName}}',
    backToDebts: 'Retour aux dettes',
    loading: 'Chargement...',
    loadingInstallments: 'Chargement des échéances...',
    noDebts: 'Aucune dette trouvée pour cet utilisateur',
    failedToLoad: 'Échec du chargement des détails de la dette',
    totalDebt: 'Dette totale',
    totalInstallments: 'Total des échéances',
    firstPaymentDate: 'Date du premier paiement',
    table: {
      number: '#',
      amount: 'Montant',
      scheduledDate: 'Date prévue',
      status: 'Statut',
      actions: 'Actions',
      noInstallments: 'Aucune échéance trouvée',
    },
    actions: {
      amountPlaceholder: 'Nouveau montant',
      processing: 'Traitement...',
      increase: 'Augmenter',
      decrease: 'Diminuer',
      payInFull: 'Payer en totalité',
      fullPaymentTitle: 'Paiement total de la dette',
      remainingToPay: 'Montant total restant',
      invalidAmount: 'Veuillez saisir un montant valide (> 0).',
      invalidDate: 'Veuillez sélectionner une date valide.',
      installmentIdMissing: 'ID de l’échéance introuvable (impossible de mettre à jour).',
      updateFailed: 'Échec de la mise à jour de l’échéance.',
      increaseSuccess: 'Échéance augmentée avec succès.',
      decreaseSuccess: 'Échéance diminuée avec succès.',
      fullPaymentSuccess: 'Paiement total effectué. Toutes les échéances sont marquées comme payées, avec les mêmes montants.',
      fullPaymentFailed: 'Échec du paiement total.',
    },
    tableDebts: {
      totalDebt: 'Dette totale',
      totalPaid: 'Total payé',
      remainingBalance: 'Solde restant',
      actions: 'Actions',
      viewDetails: 'Voir les détails de la dette',
    },
  },

  // Payment Details Modal
  paymentDetails: {
    title: 'Détails des échéances (ID: {{id}})',
    loading: 'Chargement des échéances...',
    failedToLoad: 'Échec du chargement des détails de la dette',
    noDetails: 'Aucun détail de dette disponible',
    totalDebt: 'Dette totale',
    totalInstallments: 'Total des échéances',
    firstPaymentDate: 'Date du premier paiement',
    table: {
      number: '#',
      amount: 'Montant',
      scheduledDate: 'Date prévue',
      status: 'Statut',
      actions: 'Actions',
      noInstallments: 'Aucune échéance trouvée',
    },
    actions: {
      amountPlaceholder: 'Nouveau montant',
      processing: 'Traitement...',
      increase: 'Augmenter',
      decrease: 'Diminuer',
      payInFull: 'Payer en totalité',
      fullPaymentTitle: 'Paiement total de la dette',
      remainingToPay: 'Montant total restant',
      invalidAmount: 'Veuillez saisir un montant valide (> 0).',
      invalidDate: 'Veuillez sélectionner une date valide.',
      installmentIdMissing: 'ID de l’échéance introuvable (impossible de mettre à jour).',
      updateFailed: 'Échec de la mise à jour de l’échéance.',
      increaseSuccess: 'Échéance augmentée avec succès.',
      decreaseSuccess: 'Échéance diminuée avec succès.',
      fullPaymentSuccess: 'Paiement total effectué. Toutes les échéances sont marquées comme payées, avec les mêmes montants.',
      fullPaymentFailed: 'Échec du paiement total.',
      increaseInstallmentsTitle: 'Augmenter le nombre total des échéances',
      installmentsCountPlaceholder: 'Nouveau total des échéances',
      increaseInstallments: 'Augmenter les échéances',
      invalidInstallmentsCount: 'Veuillez saisir un nombre entier valide (>= 1).',
      installmentsMustBeGreaterThanCurrent: 'Le nouveau total des échéances doit être supérieur au total actuel ({{current}}).',
      increaseInstallmentsSuccess: 'Le nombre total des échéances a été augmenté avec succès.',
      increaseInstallmentsFailed: 'Échec de l’augmentation du nombre des échéances.',
    },
  },

  // Create Consumer Modal
  createConsumer: {
    title: 'Créer un nouveau consommateur',
    bank: 'Banque',
    bankRequired: 'Banque *',
    bankHint: 'Le consommateur sera créé pour votre banque',
    firstName: 'Prénom',
    firstNameRequired: 'Prénom *',
    firstNamePlaceholder: 'Entrez le prénom',
    lastName: 'Nom',
    lastNameRequired: 'Nom *',
    lastNamePlaceholder: 'Entrez le nom',
    nni: 'NNI (Carte d\'identité nationale)',
    nniRequired: 'NNI (Carte d\'identité nationale) *',
    nniPlaceholder: 'Entrez le NNI',
    phoneNumber: 'Numéro de téléphone',
    phoneNumberRequired: 'Numéro de téléphone *',
    phoneNumberPlaceholder: '+222 XX XX XX XX',
    availableBalance: 'Solde disponible',
    availableBalanceRequired: 'Solde disponible *',
    availableBalancePlaceholder: '0.00',
    availableBalanceHint: 'Solde initial pour le compte du consommateur',
    create: 'Créer le consommateur',
    creating: 'Création en cours...',
    cancel: 'Annuler',
    messages: {
      userIdNotFound: 'ID utilisateur introuvable. Veuillez vous déconnecter et vous reconnecter.',
      nniTooShort: 'Le NNI doit contenir au moins 3 caractères',
      invalidPhone: 'Veuillez entrer un numéro de téléphone valide',
      invalidBalance: 'Le solde disponible doit être un nombre positif valide',
      createFailed: 'Échec de la création du consommateur',
    },
  },

  // File Upload Modal
  fileUpload: {
    title: 'Télécharger un fichier',
    dragActive: 'Déposez le fichier ici...',
    dragInactive: 'Glissez-déposez un fichier ici, ou cliquez pour sélectionner un fichier',
    accepts: 'Accepte',
    selectedFile: 'Fichier sélectionné',
    uploading: 'Téléchargement...',
    upload: 'Télécharger',
    cancel: 'Annuler',
  },

  // Confirmation Modal
  confirmation: {
    confirmLogout: 'Confirmer la déconnexion',
    logoutMessage: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    logout: 'Déconnexion',
    cancel: 'Annuler',
  },

  // Notification Modal
  notification: {
    downloadFailed: 'Échec du téléchargement',
    uploadSuccessful: 'Téléchargement réussi',
    uploadFailed: 'Échec du téléchargement',
    success: 'Succès',
  },

  // Status
  status: {
    paid: 'PAYÉ',
    pending: 'EN ATTENTE',
    overdue: 'EN RETARD',
  },
};

export type TranslationKey = typeof fr;

